import { render, staticRenderFns } from "./ProfQualDetails.vue?vue&type=template&id=e77d34ae&scoped=true"
import script from "./ProfQualDetails.vue?vue&type=script&lang=js"
export * from "./ProfQualDetails.vue?vue&type=script&lang=js"
import style0 from "./ProfQualDetails.vue?vue&type=style&index=0&id=e77d34ae&prod&scoped=true&lang=css"
import style1 from "./ProfQualDetails.vue?vue&type=style&index=1&id=e77d34ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e77d34ae",
  null
  
)

export default component.exports